<div fxFlex [fxLayoutAlign]="wrapperLayoutAlign" fxLayoutGap="25px">

  <div fxFlex>
    <form [formGroup]="form"> 
      <mat-form-field class="width-100">
        <input 
          matInput
          #brandInput
          formControlName="brand" 
          [matAutocomplete]="brandAC" 
          [placeholder]="'LABEL_BRAND' | translate"
          (focus)="!brandAC.isOpen && getInitialValues('brand')" 
          (blur)="checkAutocompleteObject(form, 'brand')"
          [required]="isRequired"
          >

        <mat-icon 
          id="id_select_brand_delete_btn"
          matSuffix 
          color="primary"
          class="clear-input"
          svgIcon="close-circle"
          (click)="brandInput.blur(); clearForm($event)"
          *ngIf="brandInput.value && !disabled"
          >
        </mat-icon>

        <mat-icon 
          matSuffix 
          class="clear-input"
          svgIcon="menu-down"
          *ngIf="!brandInput.value"
          >
        </mat-icon>

        <mat-autocomplete 
          id="id_select_brand_dropdown"
          [displayWith]="displayFn" 
          #brandAC="matAutocomplete" 
          (closed)="autoCmpltClosed(); brandInput.blur()"
          (opened)="autocompleteScroll('brand','brandACRef','brandACTr')"
          >
          <mat-option
            disabled
            *ngIf="!loading.brand && listData?.length == 0"
            >
            {{ 'LABEL_NO_DATA' | translate }}
          </mat-option>

          <mat-option
            [id]="'id_select_brand_data_' + (i+1)"
            [value]="data" 
            matTooltipPosition="right"
            *ngFor="let data of listData; let i = index" 
            [matTooltip]="data.code != 'all' ? data.code + ' - ' + data.description : data.description"
            >
            {{ data.code != 'all' ? (data.code + ' - ') : '' }} {{ data.description }}
          </mat-option>

          <mat-option *ngIf="loading.brand" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>

        <mat-error *ngIf="form.get('brand').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error *ngIf="form.get('brand').hasError('notExisting')">
          {{ 'MSG_DOESNT_EXIST' | translate: {type: 'LABEL_BRAND' | translate} }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  
</div>